import React from 'react';
import { Check, type Icon } from 'lucide-react';

interface SolutionCardProps {
  icon: Icon;
  title: string;
  price: string;
  description: string;
  features: string[];
}

const SolutionCard: React.FC<SolutionCardProps> = ({ 
  icon: IconComponent, 
  title, 
  price, 
  description, 
  features 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
      <div className="p-6">
        <div className="flex items-center">
          <div className="rounded-md bg-cyan-50 p-3">
            <IconComponent className="h-6 w-6 text-cyan-600" />
          </div>
          <div className="ml-4">
            <h4 className="text-lg font-medium text-gray-900">{title}</h4>
            <p className="text-sm text-cyan-600 font-medium">{price}</p>
          </div>
        </div>
        <p className="mt-4 text-base text-gray-500">{description}</p>
        <ul className="mt-4 space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <Check className="h-5 w-5 text-green-500 flex-shrink-0 mt-0.5" />
              <span className="ml-2 text-sm text-gray-500">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SolutionCard;